import React from 'react';
import { LoadingOverlay } from '@mantine/core';
import AuthenticatedApp from 'views/AuthenticatedApp';
import UnauthenticatedRoutes from 'routes/UnauthenticatedRoutes';
import { useBetterAuth } from 'context/BetterAuthProvider';

const App = () => {
  const { isLoading, isAuthenticated } = useBetterAuth();

  if (isLoading) {
    return <LoadingOverlay visible />;
  }

  return isAuthenticated ? <AuthenticatedApp /> : <UnauthenticatedRoutes />;
};

export default App;
